module.exports = __webpack_public_path__ + "img/navCards_gsjj.211c1359.png";